import { db } from "../../../config/firebaseconfig";

export default function saveAccountLicense ({
  id,
  startDate,
  endDate,
  quantity,
  licenseType
}) {
  return db.collection('accountLicenses').doc(id).update({
    startDate,
    endDate,
    licensedMax: quantity,
    licenseType,
  })
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/saveAccountLicense.js